import {get,writable} from 'svelte/store'


const isar = localStorage.getItem('locale') == null ? 'ar' : localStorage.getItem('locale')
export const locale= writable(isar)
locale.subscribe((v) => { localStorage.setItem('locale', v)})

const languagesData = {
    ar :{
        app_title: "دليل محطات التحويل الثانوية",
        btn_register:"تسجيل حساب",
        btn_login:"تسجيل دخول",
        btn_logout:"تسجيل خروج",
        btn_save:"حـفـظ",
        btn_search:"بـحـث",
        btn_cancel: "إلغاء",
        btn_search_nearme:"المحطات القريبة مني",
        btn_change_pass: "تغيير كلمة المرور",
        btn_send : "أرسل",
        btn_next : "التالي",
        btn_prev : "السابق",
        label_login_as_guest:"تسجيل دخول كزائر",
        label_before: "سابقا",
        btn_get_location: "الحصول على الموقع",
        label_change_pass: "تغيير كلمة المرور",
        btn_change_email: "تغيير البريد الإلكتروني",
        label_username:"إسم المستخدم",
        label_email: "البريد الإلكتروني",
        label_telephone:"رقم الهاتف",
        label_password:"كلمة المرور",
        label_confirm_password:"تأكيد كلمة المرور",
        label_new_password:'كلمة المرور الجديدة',
        label_re_new_password:'أعد كلمة المرور الجديدة',
        label_forgot_password : 'نسيت كلمة المرور',
        label_governorate:"المحافظة",
        label_area:"المنطقة",
        label_station_no:"رقم المحطة",        
        label_station_model:"النموذج",
        label_station_transNo:"عدد المحولات",
        label_station_address:"العنوان",
        label_station_addressNo:"الرقم اللآلي",
        label_station_location: "الموقع",
        label_latitude: "خط الطول",
        label_longitude : "خط العرض",
        label_station_ownership_type:'نوع الملكية',
        label_station_status: 'الحالة',
        label_add_station: 'أضف بيانات محطة',
        label_update_station: 'تحديث بيانات محطة',
        label_more: 'المزيد',
        label_less: 'أقل',
        label_username: 'إسم المستخدم ',
        label_fullname: 'الإسم الكامل',
        label_created_at: 'أنشئ في',
        label_updated_at: 'حدث في',
        label_created_by: 'أنشئه',
        label_updated_by: 'حدثه',           
        label_uploaded_at: 'تاريخ الرفع ',
        label_total_results:'مجموع النتائج',
        label_ticket_id: 'رقم البلاغ',
        label_add_ticket:'إضافة بلاغ',
        label_edit_ticket: 'تعديل بلاغ',
        message_no_result:"نتيجة البحث خالية",   
        error_message_already_loggedin:"لقد تم تسجيل الدخول من متصفح آخر. يجب تسجيل خروج أولا",             
        error_message_unauthorized:"خطأ : تأكد من الإسم وكلمة المرور",
        error_message_server_error:"خطأ:حدث خلل ما ,حاول مرة اخرى أو اتصل بمدير النظام",
        error_message_password_dont_match: 'كلمة المرورلا تتطابق',        
        warn_message_pass_trials : ['محاول خطأ تبقى لك  ' , ' محاولة'],
        warn_message_pass_trials : (v)=> { return  `محاول خطأ تبقى لك ${v}  محاولة`},
        success_message_pass_changed : (v) => { return `تم تغيير كلمة المرور,سيتم تسجيل خروج بعد ${v} ثانية`},
        info_message_reached_photo_limit: 'تم الوصول للحد الأقصى للعدد الصور,امسح الصور للتحديث',        
        info_message_reset_code_sent: 'سيتم إرسال رابط إعادة ضبط كلمة المرور بعد قليل,الرجاء راجع صندوق الوارد لديك',
        info_label_enter_reset_email : 'رجاءا أكتب بريدك الإلكتروني المسجل لنرسل لك الرابط',
        info_message_station_save: 'تم إضافة محطة جديدة بنجاح'

    },
    en: {
        app_title:"Trans. Stations Guide",
        btn_register:"Register",
        btn_login:"LOGIN",
        btn_logout:"LOG OUT",
        btn_save:"SAVE",
        btn_cancel : "CANCEL",
        btn_search: "SEARCH",
        btn_search_nearme: "STATIONS NEAR ME",
        btn_change_pass: "change password",
        btn_change_email:"change email",
        btn_send : "send",
        btn_get_location : "GET LOCATION",
        btn_next: "NEXT",
        btn_prev : "PREVIOUS",        
        label_login_as_guest: "log in as guest",
        label_before : "BEFORE",
        label_change_pass: "Change Password",
        label_username: "username",
        label_email : "email",
        label_telephone:"telphone",
        label_password: "password",
        label_new_password: 'new password',
        label_re_new_password : 'retype new password',
        label_confirm_password:'confirm password',
        label_forgot_password: 'forgot my password',
        label_governorate:"GOVERNORATE",
        label_area:"AREA",
        label_station_no:"STATION NO",        
        label_station_model:"MODEL",
        label_station_transNo:"No. TRANSFORMERS",
        label_station_address:"ADDRESS",
        label_station_addressNo:"ADDRESS NO",
        label_station_location: "LOCATION",
        label_latitude: "LATITUDE",
        label_longitude: "LONGITUDE",
        label_station_ownership_type:'OWNERSHIP_TYPE',
        label_station_status: 'STATUS',
        label_add_statoin : 'ADD STATION',
        label_update_station:'UPDATE STATION',
        label_username:'username',
        label_fullname:'full name',
        label_created_at : 'created at',
        label_updated_at : 'updated at',
        label_created_by : 'created by' ,
        label_updated_by : 'updated by',
        label_uploaded_at : 'upload date',
        label_more : 'more',
        label_less : 'less',
        label_total_results : 'number of results found',
        label_ticket_id: 'ticket no',
        label_add_ticket:'add ticket',
        label_edit_ticket: 'edit ticket',
        message_no_result:"SEARCH RESULT IS EMPTY",
        error_message_already_loggedin: "you already signed from anthoer browser, logout first to logout here",
        error_message_unauthorized:"ERROR: CHECK ENTERED USERNAME AND PASSWORD",
        error_message_server_error:"ERROR: SOMETHING WENT WRONG, TRY AGIN OR CONTACT ADMIN",
        error_message_password_dont_match:'password do not  match',                
        warn_message_pass_trials : (v)=> {return `failed attempt, you have : ${v} trials left`},       
        success_message_pass_changed : (v) => {`password changed, you will be logout in : ${v} second(s)`},
        info_message_reached_photo_limit:'you reached your limit of 6 photos you have to clear photos to update',
        info_message_reset_code_sent : 'a reset code will be send to your email shortly, please check your inbox',
        info_label_enter_reset_email: 'please enter your registred email recieve a reset url',
        info_message_station_save:'new station created successfully'
        
        
        
        
    }    
}


export const language = writable(languagesData[get(locale)]);
locale.subscribe((v)=>{
    let lang = v == null || v == 'ar' ?'ar' : 'en'
    language.set(languagesData[lang])
})


// const station_statuses = { 'تعمل': 'ACTIVE', 'لا تعمل': 'INACTIVE', 'قيد الإنشاء': 'UNDERCONSTRUCTION', 'موقع فقط': 'RESERVED', 'قيد الصيانة': 'MAINTENANCE' }
const station_statuses ={ 'ACTIVE': 'تعمل', 'INACTIVE': 'لا تعمل', 'UNDERCONSTRUCTION': 'قيد الإنشاء', 'RESERVED': 'موقع فقط', 'MAINTENANCE': 'قيد الصيانة' }
export function getStationStatus(status){
    
    return station_statuses[status] || status || '---'
}

const roles = {'ADMIN':'مشرف النظام','SUPERVISOR':'مراقب','CONTRACTOR':'مقاول','GUEST':'ضيف'}
export function getRole(role){
    return roles[role] || '---'
}

